import { FileText, Palette, Image, LayoutTemplate, Mic } from "lucide-react"

// order `type` key -> lucide glyph, mirroring the design handoff's TYPE_GLYPH.
// The presenter's type_key only ever returns one of these five keys (see
// OrderStatusMapping#type_key); anything else falls back to the manuscript glyph.
// Kept local to Access (D-F) — the existing type->icon maps live inside
// ProjectRow / OrderHeader and aren't exported, so re-deriving one small map here
// beats reaching into an unexported internal.
const GLYPHS = {
  manuscript: FileText,
  cover: Palette,
  illustration: Image,
  formatting: LayoutTemplate,
  narration: Mic,
}

export default function TypeGlyph({ type, className, strokeWidth = 1.9 }) {
  const Icon = GLYPHS[type] ?? FileText
  return <Icon className={className} strokeWidth={strokeWidth} />
}
